export const ROLE_KEY = {
    ADMIN: "ADMIN",
    SELLER: "SELLER",
    BUYER: "BUYER",
    DISTRIBUTOR: "DISTRIBUTOR",
}
export const ROLES  = [
  { code: ROLE_KEY.ADMIN, name: "Admin", },
  { code: ROLE_KEY.DISTRIBUTOR, name: "Distributor", },
  { code: ROLE_KEY.SELLER, name: "Seller", },
  { code: ROLE_KEY.BUYER, name: "Buyer", },
];